import { z } from 'zod';
export var GradingScheme = z.object({
  id: z.number(),
  name: z.string(),
  type: z.string(),
  max: z.union([z.string(), z.number()]).nullish()
});
export var Student = z.object({
  profile: z.object({
    id: z.number(),
    agentId: z.number().nullish(),
    email: z.string(),
    personalInformation: z.object({
      primaryEmail: z.string().nullish(),
      firstName: z.string().nullish(),
      lastName: z.string().nullish(),
      birthdate: z.string().nullish(),
      phone: z.string().nullish(),
      firstLanguage: z.string().nullish(),
      gender: z.union([z.literal('male'), z.literal('female'), z.literal('')]).nullish(),
      maritalStatus: z.union([z.literal('single'), z.literal('married')]).nullish(),
      countryOfCitizenship: z.string().nullish(),
      passportNumber: z.string().nullish(),
      passportExpiryDate: z.string().nullish()
    }),
    profilePicture: z.string().nullish(),
    residentialAddress: z.object({
      address: z.object({
        country: z.string().nullish(),
        street: z.string().nullish(),
        city: z.string().nullish(),
        province: z.string().nullish(),
        postal: z.string().nullish()
      })
    }),
    backgroundInformation: z.object({
      hasAuStudyPermit: z["boolean"]().nullish(),
      hasCaStudyPermit: z["boolean"]().nullish(),
      hasDeStudyPermit: z["boolean"]().nullish(),
      hasGbStudyPermit: z["boolean"]().nullish(),
      hasIeStudyPermit: z["boolean"]().nullish(),
      hasUsStudyPermit: z["boolean"]().nullish(),
      refusalOfEntry: z["boolean"]().nullish(),
      informationText: z.string().nullish()
    }),
    educationSummary: z.object({
      educationLevelId: z.number().nullish(),
      gradingScheme: z.number().nullish(),
      gradeScale: z.number().nullish(),
      grade: z.union([z.string(), z.number()]).nullish(),
      educationCountry: z.string().nullish(),
      graduated: z["boolean"](),
      educationLevels: z.array(z.object({
        id: z.number(),
        name: z.string()
      })),
      gradingSchemes: z.array(GradingScheme)
    }),
    studentId: z.number(),
    testScores: z.object({
      englishExamType: z.union([z.literal('ielts'), z.literal('toefl'), z.literal('duolingo_english'), z.literal('pte'), z.literal('provide_later')]).nullish(),
      ielts: z.object({
        listening: z.number(),
        reading: z.number(),
        writing: z.number(),
        speaking: z.number(),
        average: z.number(),
        examDate: z.string().nullish(),
        referenceNumber: z.string().nullish()
      }).nullish(),
      toefl: z.object({
        listening: z.number(),
        reading: z.number(),
        writing: z.number(),
        speaking: z.number(),
        total: z.number(),
        examDate: z.string().nullish()
      }).nullish(),
      duolingoEnglish: z.object({
        examDate: z.string().nullish(),
        total: z.number()
      }).nullish(),
      pte: z.object({
        listening: z.number(),
        reading: z.number(),
        writing: z.number(),
        speaking: z.number(),
        total: z.number(),
        examDate: z.string().nullish()
      }).nullish()
    }).nullish(),
    additionalQualifications: z.object({
      gmat: z.object({
        examDate: z.string().nullish(),
        verbalScore: z.string(),
        verbalRank: z.string(),
        quantitativeScore: z.string(),
        quantitativeRank: z.string(),
        writingScore: z.string(),
        writingRank: z.string(),
        totalScore: z.string(),
        totalRank: z.string()
      }).nullish(),
      gre: z.object({
        examDate: z.string().nullish(),
        verbalScore: z.string(),
        verbalRank: z.string(),
        quantitativeScore: z.string(),
        quantitativeRank: z.string(),
        writingScore: z.string(),
        writingRank: z.string()
      }).nullish()
    }).nullish()
  }),
  countryVisaPermitReferenceTypes: z.array(z.object({
    value: z.union([z.literal('has_au_study_permit'), z.literal('has_ca_study_permit'), z.literal('has_de_study_permit'), z.literal('has_gb_study_permit'), z.literal('has_ie_study_permit'), z.literal('has_us_study_permit')]),
    label: z.string()
  })),
  totalApplications: z.number(),
  attendedSchools: z.array(z.object({
    schoolName: z.string().nullish(),
    hasGraduated: z["boolean"](),
    level: z.union([z.number(), z.string()]),
    language: z.string().nullish(),
    startDate: z.string().nullish(),
    endDate: z.string().nullish(),
    degreeName: z.string().nullish(),
    dateGraduated: z.string().nullish(),
    degreeAwarded: z["boolean"]().nullish(),
    schoolAddress: z.object({
      street: z.string().nullish(),
      city: z.string().nullish(),
      postal: z.string().nullish(),
      province: z.string().nullish(),
      country: z.string().nullish()
    })
  }))
});
export var StudentResponse = z.object({
  type: z.literal('student'),
  attributes: z.object({}).passthrough()
});